const PAGE_BREAK_BOXES = [
    '& *:not(:last-child) > .printout-block-shell[data-printout-block-type="printoutPageBreak"]',
    '& *:not(:last-child):has(> .printout-block-shell[data-printout-block-type="printoutPageBreak"])',
    '& .printout-rendered-page-break-block:not(:last-child)',
].join(', ');

export const pageBreakBlockSx = {
    '& .printout-page-break-fill': {
        width: '100%',
        // Replace the screen fill with a real print break.
        '@media print': {
            height: '0 !important',
        },
    },
    '& .printout-rendered-page-break-block': {
        width: '100%',
    },
    // A final explicit break must not create an empty trailing page.
    [PAGE_BREAK_BOXES]: {
        '@media print': {
            breakAfter: 'page',
            pageBreakAfter: 'always',
        },
    },
};
